/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(){this.drawPhase=217}startup(){}shutdown(s){}}export{s as Technique};
